import React from 'react'
import PropTypes from 'prop-types'
import PersonalFields from './personal-fields'
import BillingFields from './billing-fields'

import PaymentDetailFields from './payment-details-fields'

const Fields = ({ planDetails, clientApplyCode, form, invitationId, plan, place }) => {
  return (
    <div className="flex md:flex-row flex-col">
      <div className="flex-1 lg:flex-1 sm:flex-0 mx-10">
        <h1 className="text-3xl text-primary-seafoam">Confirm and Pay</h1>
        <PersonalFields />
        <BillingFields
          clientApplyCode={clientApplyCode}
          form={form}
          invitationId={invitationId}
          plan={plan}
          place={place}
        />
      </div>
      <div className="flex-1 lg:flex-1 sm:flex-0 mx-10">
        <PaymentDetailFields planDetails={planDetails} />
      </div>
    </div>
  )
}

Fields.propTypes = {
  planDetails: PropTypes.object,
  clientApplyCode: PropTypes.func,
  form: PropTypes.string,
  invitationId: PropTypes.string,
  plan: PropTypes.string,
  place: PropTypes.string,
}

export default Fields
